<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}</h3>
                </header>
            </section>
            <div class="divisor8"></div>
            <section class="widget">
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                        <div class="row margen">
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Persona evaluada'"
                                [(ngModel)]="entidad.colaborador"
                                [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Ciclo'"
                                [(ngModel)]="periodoevaluacion.ciclo"
                                [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Periodo de evaluación'"
                                [(ngModel)]="periodoevaluacion.descripcion"
                                [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Puesto'"
                                [(ngModel)]="entidad.puesto"
                                [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Departamento'"
                                [(ngModel)]="entidad.departamento"
                                [disabled]="true"></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Nivel'"
                                [(ngModel)]="entidad.nivel"
                                [disabled]="true"></inputCustom>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <div class="base">
                            <div class="esqueletoboton">
                                <button class="boton botonSM filledBlanco margenboton" (click)="Generarpdf()">Generar PDF</button>
                            </div>
                            <div class="margenimagen" *ngIf="entidad.urlfotografia">
                                <div class="imagencolaborador">
                                    <imagenVisualizador [imagen]="entidad.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit"></imagenVisualizador>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <dx-tab-panel [animationEnabled]="true"  style="max-height: 40rem;" [(selectedIndex)]="selectedTabIndex">
                  <dxi-item title="General" >
                    <reporteevaluaciondetalle_general #general
                    [general]="entidad"
                    [periodo]="periodoevaluacion"
                    [listapuesto]="listapuesto"
                    >
                    </reporteevaluaciondetalle_general>
                  </dxi-item>
                  <dxi-item title="Alumnos">
                    <div></div>
                    <reporteevaluaciondetalle_alumno #alumno
                    [general]="entidad"
                    [periodo]="periodoevaluacion"
                    [listapuesto]="listapuesto"
                    >
                    </reporteevaluaciondetalle_alumno>
                  </dxi-item>
                  <dxi-item title="Padres de familia">
                    <div></div>
                    <reporteevaluaciondetalle_padre  #padre
                    [general]="entidad"
                    [periodo]="periodoevaluacion"
                    [listapuesto]="listapuesto"
                    >
                    </reporteevaluaciondetalle_padre>
                  </dxi-item>
                  <dxi-item title="Alumnos - Talleres extracurriculares">
                    <div></div>
                    <reporteevaluaciondetalle_talleralumno  #alumnotaller
                    [general]="entidad"
                    [periodo]="periodoevaluacion"
                    [listapuesto]="listapuesto"
                    >
                    </reporteevaluaciondetalle_talleralumno>
                  </dxi-item>
                  <dxi-item title="Padres de familia - Talleres extracurriculares">
                    <div></div>
                    <reporteevaluaciondetalle_tallerpadre  #padretaller
                    [general]="entidad"
                    [periodo]="periodoevaluacion"
                    [listapuesto]="listapuesto"
                    >
                    </reporteevaluaciondetalle_tallerpadre>
                  </dxi-item>
              </dx-tab-panel>

                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cerrar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
